import axios from 'axios'

const { REQUEST_ERROR } = livecloud
// 创建一个axios实例
const apiInstance = axios.create()

apiInstance.defaults.headers['Content-Type'] = 'application/json'

// const basenameReg = new RegExp(livecloud.basename)

// 添加请求拦截器
apiInstance.interceptors.request.use(
  // undefined,
  config => {
    if (config.method === 'get') {
      // config.headers.set('Content-Type', 'application/json')
      config.data = { unused: 0 } // 这个是关键点，加入这行就可以了,解决get,请求添加不上Content-Type
    } else if (config.data instanceof FormData) {
      config.headers.set('Content-Type', 'formData')
    }
    return config
  },
  error => {
    // 处理错误请求，弹出错误提示并返回REQUEST_ERROR常量
    livecloud.tip.error(error.message)
    return REQUEST_ERROR
  }
)

// 添加响应拦截器
apiInstance.interceptors.response.use(
  response => {
    const data = response.data
    if (data.success || data.code === 1) {
      // 如果success为true，则直接返回data数据
      return data
    } else {
      // 如果success为false，则弹出错误提示并返回REQUEST_ERROR常量
      data.data = REQUEST_ERROR
      livecloud.tip.error(data.msg || data.note)
      return data
    }
  },
  error => {
    // 处理错误响应，弹出错误提示并返回REQUEST_ERROR常量
    livecloud.tip.error(error.message)
    return REQUEST_ERROR
  }
)

export {
  apiInstance
}